import React, { useEffect } from "react";
import "./home.scss";

function MobileSlides({ background }) {
	const image = new Image()
	image.src = background

	useEffect(()=>{
		console.log(image.src,'imageimage')
	},[image])
	return (
		<div>
			<div style={{ backgroundImage: `url(${image.src})` }} className="slideMobile"></div>
			<div className="sec1HeadMobile">
				<h6 className="small-title" data-aos="fade-up">
					CERTIFIED GEMSTONES TESTING
				</h6>
				<h2 data-aos="fade-down">
					MOST TRUSTED
					<br />
					<span>
						DIAMOND & <br /> GEM{" "}
					</span>{" "}
					IDENTIFICATION
				</h2>
			</div>
		</div>
	);
}

export default MobileSlides;
